const darkModeConversionTable = {
  // text color
  "#050505": "#EDEDED",
  "#FFF": "#141414",
  "#FFFFFF": "#141414",
  // true black to true white
  "#000": "#FFFFFF",
  "#000000": "#FFFFFF",
  "#010101": "#FFFFFF",
  // graph marking and line color
  "#666666": "#B8B8B8",
  "#666": "#B8B8B8",
  // red-palette
  "#EF7171": "#980806",
  "#DA000D": "#DA000D",
  "#980806": "#EF7171",
  // green-palette
  "#BFEDDC": "#167057",
  "#60bCA1": "#60bCA1",
  "#167057": "#BFEDDC",
  // pink-palette
  "#FFCFE4": "#9F0A47",
  "#FF589B": "#FF589B",
  "#9F0A47": "#FFCFE4",
  // yellow-palette
  "#FDC226": "#CC5A05",
  "#F58D2D": "#F58D2D",
  "#CC5A05": "#FDC226",
  // blue-palette
  "#C1DCEE": "#173D56",
  "#568CBB": "#568CBB",
  "#173D56": "#C1DCEE",
  // grey-scale-palette
  "#F2F2F2": "#4D4D4D",
  "#D9D9D9": "#737373",
  "#A6A6A6": "#A6A6A6",
  "#737373": "#D9D9D9",
  "#4D4D4D": "#F2F2F2",
};

const transformElementFromTable = (element) => {
  ["fill", "stroke"].forEach((attr) => {
    const color = element.getAttribute(attr);
    if (color && darkModeConversionTable[color.toUpperCase()]) {
      element.setAttributeNS(
        null,
        attr,
        darkModeConversionTable[color.toUpperCase()]
      );
    }
  });
  return element;
};

const transformElementFromHexValue = (element, hexValue) => {
  ["fill", "stroke"].forEach((attr) => {
    const color = element.getAttribute(attr);
    if (color) {
      element.setAttributeNS(
        null,
        attr,
        hexValue,
      );
    }
  });
  return element;
};

function ensureString(svg) {
  if (typeof svg === "string") return svg;

  // Om det är ett SVGDocument eller Element, använd XMLSerializer
  try {
    return new XMLSerializer().serializeToString(svg);
  } catch (e) {
    console.warn("Kunde inte konvertera SVG till sträng:", e);
    return "";
  }
}

function parseSvgString(svgString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(svgString, "image/svg+xml");
  return doc.documentElement;
}

const addTags = (svgString, altDescription) => {
  if (!altDescription) return svgString;
  if (typeof svgString !== "string") return svgString;

  // Lägg till role och aria-labelledby om de inte redan finns
  svgString = svgString.replace(
    /<svg\b([^>]*)>/,
    (match, attrs) => {
      if (!attrs) return match;

      const hasRole = /role\s*=/.test(attrs);
      const hasAria = /aria-labelledby\s*=/.test(attrs);

      let newAttrs = attrs;
      if (!hasRole) newAttrs += ` role="img"`;
      if (!hasAria) newAttrs += ` aria-labelledby="logo-title"`;

      return `<svg${newAttrs}>`;
    }
  );

  // Lägg till title-taggen om den inte redan finns
  if (!svgString.includes('id="logo-title"')) {
    svgString = svgString.replace(
      /<svg[^>]*>/,
      (match) => `${match}\n  <title id="logo-title">${altDescription}</title>`
    );
  }

  return svgString;
};

const addAltTagToSvg = (svgElement, altDescription) => {
  
  if (!altDescription) return svgElement;
  const svgString = ensureString(svgElement);
  const updatedSvgString = addTags(svgString, altDescription);
  svgElement = parseSvgString(updatedSvgString); // 🧠 Konvertera tillbaka till DOM-element

  return svgElement;
}

export const transformSvgToDarkMode = (svgElement, darkMode, altDescription = "" ) => {

  svgElement = addAltTagToSvg(svgElement, altDescription);

  if (!darkMode) return svgElement;
  const elements = svgElement.querySelectorAll(":scope > *");
  
  elements.forEach((element) => {
    if (!element.getAttribute("id")) {
      if (element.children.length > 0) {
        transformSvgToDarkMode(element, darkMode);
      } else {
        transformElementFromTable(element);
      }
    } else if (element.getAttribute("id").toLowerCase().includes("översätt:")) {
      let hexValue = element.getAttribute("id").split(":")[1].replace('_x23_', '#')
      transformElementFromHexValue(element, hexValue)
    } else if (!element.getAttribute("id").toLowerCase().includes("bevara")) {
      if (element.children.length > 0) {
        transformSvgToDarkMode(element, darkMode);
      } else {
        transformElementFromTable(element);
      }
    }
  });
  return svgElement;
};
